// Onboarding-gated demo-data policy.
//
// Hard rule (Steve, 2026-06-05): a REAL retailer account must NEVER be shown
// demo / showcase / seed figures. The platform tells real-account-vs-showcase
// apart via `retailers.onboarding_complete` (surfaced on `ctx.user`):
//
//   • onboarding_complete === true   → an established, onboarded retailer.
//       Live data is authoritative; demo data may only ever be used as a
//       deliberate showcase here (today there is none — all demo data was
//       stripped to empty/zero state).
//   • anything else (false / unknown / anonymous / pre-/portal/me paint)
//       → treat as a real, not-yet-onboarded account → empty/zero state.
//       NEVER demo.
//
// Pages that previously carried hardcoded demo data import `demoDataAllowed`
// and use it to decide whether their (now empty) demo fallback may render.
// Because the safe default is `false`, any future re-introduction of demo
// content is automatically suppressed for real accounts.

import type { PageContext } from "./types";

/**
 * `true` only when the signed-in retailer has explicitly completed onboarding.
 * Use this to gate ANY non-live (demo/showcase/seed) fallback. When it returns
 * `false`, render the empty/zero state instead.
 */
export function demoDataAllowed(ctx: PageContext): boolean {
  return ctx.user?.onboardingComplete === true;
}
